// import React, { useEffect, useState } from "react";
// import dataService from "../networks/api/service/dataService";
// import {
//   Select,
//   Card,
//   Typography,
//   Descriptions,
//   Spin,
//   Button,
//   Table,
//   Row,
//   Col,
//   message,
// } from "antd";
// import { InfoCircleOutlined } from "@ant-design/icons";
// import CustomTable from "../components/TableComponent/CustomTable";
// const { Option } = Select;

// const { Text, Title } = Typography;

// function AssemblyDetails() {
//   const [data, setData] = useState([]);
//   const [selectedAssembly, setSelectedAssembly] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [tableData, setTableData] = useState([]);
//   const [tableColumns, setTableColumns] = useState([]);
//   const [tableTitle, setTableTitle] = useState("");
//   const [year, setYear] = useState(null);

//   const OnYearSelect = (value) => {
//     setYear(value);
//   };

//   // Fetch assembly details
//   const getAssemblyDetails = async () => {
//     try {
//       const response = await dataService.getAssemblyBasedAdmin();
//       setData(response.data);
//       setSelectedAssembly(response.data[0]);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getElectionDetailsAssembly = async () => {
//     setLoading(true);
//     if (year) {
//       try {
//         const response = await dataService.getAssemblyEDAssembly(
//           selectedAssembly._id,
//           year
//         );
//         if (response.code === 200) {
//           setTableTitle(`${selectedAssembly.assemblyName} - Assembly Details`);
//           generateDynamicTable(response.data);
//         } else {
//           message.error("something went wrong");
//         }
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     } else {
//       message.warning("Select Year");
//       setLoading(false);
//     }
//   };

//   const getElectionDetailsConstituency = async () => {
//     setLoading(true);
//     if (year) {
//       try {
//         const response = await dataService.getAssemblyEDConstituency(
//           selectedAssembly._id,
//           year
//         );
//         if (response.code === 200) {
//           setTableTitle(
//             `${selectedAssembly.assemblyName} - Constituency Details`
//           );
//           generateDynamicTable(response.data);
//         } else {
//           message.error("something went wrong");
//         }
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     } else {
//       message.warning("Select Year");
//       setLoading(false);
//     }
//   };

//   const generateDynamicTable = (responseData) => {
//     if (responseData.length > 0) {
//       // Filter out keys ending with "_bgColor"
//       const columns = Object.keys(responseData[0])
//         .filter((key) => !key.endsWith("_bgColor")) // Exclude _bgColor keys
//         .map((key) => ({
//           title: key.replace(/([A-Z])/g, " $1").toUpperCase(),
//           dataIndex: key,
//           key: key,
//           render: (text, record) => {
//             // Apply color scheme for Rank column
//             if (key.toLowerCase() === "rank") {
//               let backgroundColor;
//               if (text === 1) {
//                 backgroundColor = "orange";
//               } else if (text === 2) {
//                 backgroundColor = "yellow";
//               } else if (text === 3) {
//                 backgroundColor = "red";
//               } else {
//                 backgroundColor = "transparent";
//               }

//               return (
//                 <div
//                   style={{
//                     backgroundColor: backgroundColor,
//                     padding: "10px",
//                     borderRadius: "5px",
//                     textAlign: "center",
//                     color: "black",
//                   }}
//                 >
//                   {text}
//                 </div>
//               );
//             }

//             // Apply color scheme for percentage column
//             if (key.toLowerCase().includes("%") && typeof text === "number") {
//               let backgroundColor;
//               if (text < 30) {
//                 backgroundColor = "red";
//               } else if (text >= 30 && text <= 45) {
//                 backgroundColor = "yellow";
//               } else {
//                 backgroundColor = "orange";
//               }

//               return (
//                 <div
//                   style={{
//                     backgroundColor: backgroundColor,
//                     padding: "10px",
//                     borderRadius: "5px",
//                     textAlign: "center",
//                     color: "black",
//                   }}
//                 >
//                   {parseFloat(text).toFixed(2)}%
//                 </div>
//               );
//             }

//             // Apply custom background colors from _bgColor fields
//             const bgColor = record[`${key}_bgColor`];
//             if (bgColor) {
//               return (
//                 <div
//                   style={{
//                     backgroundColor: bgColor,
//                     padding: "10px",
//                     borderRadius: "5px",
//                     textAlign: "center",
//                     color: "black",
//                   }}
//                 >
//                   {text}
//                 </div>
//               );
//             }

//             return text;
//           },
//         }));

//       setTableColumns(columns);
//       setTableData(responseData);
//     } else {
//       setTableColumns([]);
//       setTableData([]);
//     }
//   };

//   useEffect(() => {
//     getAssemblyDetails();
//   }, []);

//   const getAssemblyDetailsById = async (id) => {
//     try {
//       const response = await dataService.getAssemblyBasedAdminId(id);
//       setSelectedAssembly(response.data);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAssemblySelect = (assemblyId) => {
//     // const assembly = data.find((a) => a._id === assemblyId);
//     // setSelectedAssembly(assembly);
//     getAssemblyDetailsById(assemblyId);
//     setTableData([]);
//     setTableColumns([]);
//     setTableTitle("");
//   };

//   return (
//     <div
//       style={{
//         padding: "15px",
//         backgroundColor: "#f0f2f5",
//         minHeight: "100vh",
//       }}
//     >
//       <Row justify="center">
//         <Col span={24} style={{ textAlign: "center", marginBottom: "20px" }}>
//           <Title level={3}>Assembly Details</Title>
//         </Col>
//       </Row>

//       <Row justify="center" style={{ marginBottom: "20px" }}>
//         <Col xs={24} sm={16} md={12} lg={8}>
//           <Select
//             showSearch
//             optionFilterProp="children"
//             filterOption={(input, option) => {
//               const children = option?.children;
//               return String(children)
//                 .toLowerCase()
//                 .includes(input.toLowerCase());
//             }}
//             placeholder="Select an Assembly"
//             style={{ width: "100%", border: "1px solid grey", borderRadius: 5 }}
//             value={selectedAssembly?._id}
//             onChange={handleAssemblySelect}
//             loading={loading}
//           >
//             {data?.map((assembly) => (
//               <Select.Option key={assembly._id} value={assembly._id}>
//                 {assembly.assemblyName}
//               </Select.Option>
//             ))}
//           </Select>
//         </Col>
//       </Row>

//       {loading ? (
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <Spin size="large" />
//         </div>
//       ) : (
//         selectedAssembly && (
//           <Card
//             style={{
//               marginBottom: "20px",
//               borderRadius: "8px",
//               boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
//             }}
//             title={
//               <span
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   fontSize: "1.4em",
//                   fontWeight: "500",
//                   color: "#595959",
//                 }}
//               >
//                 <InfoCircleOutlined
//                   style={{ marginRight: "10px", color: "#1890ff" }}
//                 />
//                 Assembly Information
//               </span>
//             }
//             bordered
//           >
//             <Descriptions bordered column={1} size="middle">
//               <Descriptions.Item label="Assembly Name">
//                 <Text strong>{selectedAssembly.assemblyName}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Booth">
//                 <Text>{selectedAssembly.totalBooth}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Population">
//                 <Text>{selectedAssembly.totalPopulation}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Voters">
//                 <Text>{selectedAssembly.totalVoter}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Male Voters">
//                 <Text>{selectedAssembly.totalMaleVoter}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Female Voters">
//                 <Text>{selectedAssembly.totalFemaleVoter}</Text>
//               </Descriptions.Item>
//             </Descriptions>
//           </Card>
//         )
//       )}

//       <Row justify="center" gutter={[16, 16]}>
//         <Col>
//           <Button
//             type="primary"
//             onClick={getElectionDetailsAssembly}
//             disabled={!selectedAssembly}
//           >
//             Assembly Details
//           </Button>
//         </Col>
//         {/* <Col>
//           <Button
//             type="primary"
//             onClick={getElectionDetailsConstituency}
//             disabled={!selectedAssembly}
//           >
//             Parliament Details
//           </Button>
//         </Col> */}
//         <Col xs={24} sm={12} md={8}>
//           <Select
//             showSearch
//             optionFilterProp="children"
//             filterOption={(input, option) => {
//               const children = option?.children;
//               return String(children)
//                 .toLowerCase()
//                 .includes(input.toLowerCase());
//             }}
//             placeholder="Select Year"
//             style={{ width: "100%", border: "1px solid grey", borderRadius: 5 }}
//             onChange={OnYearSelect}
//             value={year}
//             disabled={!selectedAssembly}
//           >
//             <Option disabled>Select Year</Option>

//             {[2024, 2019, 2014].map((y) => (
//               <Option key={y} value={y}>
//                 {y}
//               </Option>
//             ))}
//           </Select>
//         </Col>
//       </Row>

//       <div style={{ marginTop: "20px" }}>
//         {tableTitle && (
//           <Title
//             level={4}
//             style={{ marginBottom: "10px", textAlign: "center" }}
//           >
//             {tableTitle}
//           </Title>
//         )}
//         <CustomTable
//           dataSource={tableData}
//           columns={tableColumns}
//           rowKey={(record) => record._id || record.key}
//           bordered
//           loading={loading}
//           pagination={true}
//           size="middle"
//           style={{
//             boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//             borderRadius: "8px",
//             backgroundColor: "#fff",
//             width: "100%",
//             overflowX: "auto",
//           }}
//           scroll={{ x: 800 }}
//         />
//       </div>
//     </div>
//   );
// }

// export default AssemblyDetails;

import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import AboutComp from "../components/AboutComp";
import { Breadcrumb, Spin, Table, Input, Space } from "antd";

const { Search } = Input;
const LEVELS = [
  { key: "blockName", title: "Block Name" },
  { key: "panchayatName", title: "Panchayat Name" },
  { key: "boothName", title: "Booth Name" },
  { key: "villageName", title: "Village Name" },
];
function AssemblyDetails() {
  const [assemblyData, setAssemblyData] = useState(null);
  const adminRoleId = localStorage.getItem("adminRoleId");
  const [currentLevel, setCurrentLevel] = useState(0);
  const [loadingId, setLoadingId] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [blockData, setBlockData] = useState([]);
  const [panchayatData, setPanchayatData] = useState([]);
  const [boothData, setBoothData] = useState([]);
  const [villageData, setVillageData] = useState([]);

  useEffect(() => {
    const getBlockData = async () => {
      try {
        const res = await dataService.aboutAssemblyBlock(adminRoleId);
        if (res.code === 200) {
          setBlockData(res.data);
        }
      } catch (e) {
        console.error("Error fetching block details:", e);
      }
    };

    getBlockData();
  }, []);

  const fetchNextLevel = async (id, name, nextLevel) => {
    if (nextLevel >= LEVELS.length) return;

    setLoadingId(id);
    let response;

    try {
      const currentKey = LEVELS[currentLevel].key;
      if (currentKey === "blockName")
        response = await dataService.aboutAssemblyPanchayat(id);
      if (currentKey === "panchayatName")
        response = await dataService.aboutAssemblyBooth(id);
      if (currentKey === "boothName")
        response = await dataService.aboutAssemblyVillage(id);

      setCurrentLevel(nextLevel);
      setBreadcrumb([...breadcrumb, { name, id }]);

      switch (nextLevel) {
        case 1:
          setPanchayatData(response.data);
          break;
        case 2:
          setBoothData(response.data);
          break;
        case 3:
          setVillageData(response.data);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Error fetching next level:", error);
    }
    setLoadingId(null);
  };

  const goBack = (level) => {
    setCurrentLevel(level);
    setBreadcrumb(breadcrumb.slice(0, level));
  };

  const currentKey = LEVELS[currentLevel].key;
  const currentTitle = LEVELS[currentLevel].title;
  const currentData = [blockData, panchayatData, boothData, villageData][
    currentLevel
  ];

  const filteredData = currentData.filter((item) =>
    item[currentKey]?.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: currentTitle,
      dataIndex: currentKey,
      key: currentKey,
      render: (text, record) =>
        loadingId === record._id ? (
          <Spin />
        ) : (
          <span
            style={{ cursor: "pointer", color: "blue" }}
            onClick={() => fetchNextLevel(record._id, text, currentLevel + 1)}
          >
            {text}
          </span>
        ),
    },
  ];

  const getAssembly = async () => {
    try {
      const res = await dataService.getAboutAssembly(adminRoleId);
      if (res.code === 200 && res.data) {
        setAssemblyData(res.data);
      }
    } catch (e) {
      console.error("Error fetching assembly details:", e);
    }
  };

  useEffect(() => {
    getAssembly();
  }, []);

  return (
    <>
      {assemblyData ? (
        <AboutComp
          title="Assembly"
          area={assemblyData.geographicalArea}
          candidates={assemblyData.electedCandidate}
          mapImage={assemblyData?.map}
        />
      ) : (
        <p style={{ textAlign: "center", color: "red" }}>Failed to load data</p>
      )}

      <div style={{ padding: 20, maxWidth: 500, margin: "auto" }}>
        {breadcrumb.length > 0 && (
          <Breadcrumb style={{ marginBottom: 10 }}>
            <Breadcrumb.Item
              onClick={() => goBack(0)}
              style={{ cursor: "pointer" }}
            >
              Block
            </Breadcrumb.Item>
            {breadcrumb.map((item, index) => (
              <Breadcrumb.Item
                key={index}
                onClick={() => goBack(index + 1)}
                style={{ cursor: "pointer" }}
              >
                {item.name}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        )}

        <Space
          style={{
            marginBottom: 10,
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <Search
            placeholder={`Search ${currentTitle}`}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 200 }}
          />
        </Space>

        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="_id"
          pagination={{ pageSize: 5 }}
        />
      </div>
    </>
  );
}

export default AssemblyDetails;
